'use client';

import { ProductCardData } from '@/types/Product';

const TIER_DISPLAY_NAMES: Record<string, string> = {
  Privee: 'Réservé'
};

export function displayTierName(tier: string): string {
  return TIER_DISPLAY_NAMES[tier] ?? tier;
}

export async function fetchProductCardDataById(
  productId: string
): Promise<ProductCardData> {
  try {
    const response = await fetch(`/api/product?id=${productId}`);

    if (!response.ok) {
      console.error(
        `fetchProductCardDataById() - Error fetching product ${productId}`
      );
      // Return well-formed product object, it's better than nothing
      return {
        id: productId,
        borrowed: false,
        brand: '',
        slug: '',
        sku: '',
        name: '',
        tier: '',
        mainImage: '',
        color: [],
        item_group_id: ''
      };
    }

    let responseJSON;
    try {
      responseJSON = await response.json();
    } catch (error) {
      return {
        id: productId,
        borrowed: false,
        brand: '',
        slug: '',
        sku: '',
        name: '',
        tier: '',
        mainImage: '',
        color: [],
        item_group_id: ''
      };
    }

    const productData = responseJSON?.data;
    if (!productData) {
      console.error(`No product data found for ${productId}`);
      return {
        id: productId,
        borrowed: false,
        brand: '',
        slug: '',
        sku: '',
        name: '',
        tier: '',
        mainImage: '',
        color: [],
        item_group_id: ''
      };
    }

    return {
      id: productData.id,
      borrowed: productData.borrowed || false,
      brand: productData.brand || '',
      name: productData.productName || '',
      slug: productData.slug || '',
      sku: productData.sku || '',
      tier: productData.productTier || '',
      mainImage: productData.images?.[0] || '',
      color: productData.color || [],
      item_group_id: productData.sku || ''
    };
  } catch (error) {
    console.error(`fetchProductCardDataById failed for ${productId}:`, error);
    return {
      id: productId,
      borrowed: false,
      brand: '',
      slug: '',
      sku: '',
      name: '',
      tier: '',
      mainImage: '',
      color: [],
      item_group_id: ''
    };
  }
}
